module.exports = __webpack_public_path__ + "img/consultoria_3-4_512.14730892.jpg";